module.exports = __webpack_public_path__ + "static/media/portfolio_landing_banner.ab5fc6a8.svg";